import { Component, DestroyRef, inject } from '@angular/core';
import { SummaryService } from '../../services/summary.service';
import { SummaryCardItemComponent } from '../summary-card-item/summary-card-item.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';

@Component({
  selector: 't-llevo-summary-cards-collection',
  standalone: true,
  imports: [SummaryCardItemComponent],
  template: `
    <div class="row">
      @for(card of cardsConfig; track card){
      <div class="col-sm-6 col-md-4 col-lg-3 py-2">
        <t-llevo-summary-card-item
          [bgColor]="card.bgColor"
          [fontColor]="card.fontColor"
          [cardTitle]="card.cardTitle"
          [value]="summarySrv.getValueById(card.id)"
          [svgIcon]="card.svgIcon"
          [svgColor]="card.svgColor"
          class="w-100 d-block"
        >
        </t-llevo-summary-card-item>
      </div>
      }
    </div>
  `,
})
export class SummaryCardsCollectionComponent {
  protected summarySrv = inject(SummaryService);
  protected cardsConfig = this.summarySrv.getCardsConfig();
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.summarySrv.getCardsData().pipe(take(1)).subscribe();

    this.summarySrv
      .updateInterval(20000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}